// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-56c9c89e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.list-item__wrapper[data-v-56c9c89e] {
  display: flex;
  position: relative;
  width: 100%;
  padding: 2px 4px;
}
.list-item__wrapper[data-v-56c9c89e]:first-of-type {
  padding-block-start: 4px;
}
.list-item__wrapper[data-v-56c9c89e]:last-of-type {
  padding-block-end: 4px;
}
.list-item__wrapper--active .list-item[data-v-56c9c89e], .list-item__wrapper.active .list-item[data-v-56c9c89e] {
  background-color: var(--color-primary-element);
  color: var(--color-primary-element-text) !important;
}
.list-item__wrapper--active .list-item[data-v-56c9c89e]:hover, .list-item__wrapper--active .list-item[data-v-56c9c89e]:focus-within, .list-item__wrapper--active .list-item[data-v-56c9c89e]:has(:focus-visible), .list-item__wrapper--active .list-item[data-v-56c9c89e]:has(:active), .list-item__wrapper.active .list-item[data-v-56c9c89e]:hover, .list-item__wrapper.active .list-item[data-v-56c9c89e]:focus-within, .list-item__wrapper.active .list-item[data-v-56c9c89e]:has(:focus-visible), .list-item__wrapper.active .list-item[data-v-56c9c89e]:has(:active) {
  background-color: var(--color-primary-element-hover);
}
.list-item__wrapper--active .list-item-content__name[data-v-56c9c89e],
.list-item__wrapper--active .list-item-content__subname[data-v-56c9c89e],
.list-item__wrapper--active .list-item-content__details[data-v-56c9c89e],
.list-item__wrapper--active .list-item-details__details[data-v-56c9c89e], .list-item__wrapper.active .list-item-content__name[data-v-56c9c89e],
.list-item__wrapper.active .list-item-content__subname[data-v-56c9c89e],
.list-item__wrapper.active .list-item-content__details[data-v-56c9c89e],
.list-item__wrapper.active .list-item-details__details[data-v-56c9c89e] {
  color: var(--color-primary-element-text) !important;
}
.list-item__wrapper .list-item-content__name[data-v-56c9c89e],
.list-item__wrapper .list-item-content__subname[data-v-56c9c89e],
.list-item__wrapper .list-item-content__details[data-v-56c9c89e],
.list-item__wrapper .list-item-details__details[data-v-56c9c89e] {
  white-space: nowrap;
  margin-block: 0;
  margin-inline: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-item-content__name[data-v-56c9c89e] {
  min-width: 100px;
  flex: 1 1 10%;
  font-weight: 500;
}
.list-item-content__subname[data-v-56c9c89e] {
  flex: 1 0;
  min-width: 0;
  color: var(--color-text-maxcontrast);
}
.list-item-content__subname--bold[data-v-56c9c89e] {
  font-weight: 500;
}
.list-item[data-v-56c9c89e] {
  --list-item-padding: var(--default-grid-baseline);
  --list-item-height: 2lh;
  --list-item-border-radius: var(--border-radius-element, 32px);
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: var(--list-item-padding);
  width: 100%;
  border-radius: var(--border-radius-element, 32px);
  cursor: pointer;
  transition: background-color var(--animation-quick) ease-in-out;
  list-style: none;
}
.list-item[data-v-56c9c89e]:hover, .list-item[data-v-56c9c89e]:focus-within, .list-item[data-v-56c9c89e]:has(:active), .list-item[data-v-56c9c89e]:has(:focus-visible) {
  background-color: var(--color-background-hover);
}
.list-item[data-v-56c9c89e]:has(.list-item__anchor:focus-visible) {
  outline: 2px solid var(--color-main-text);
  box-shadow: 0 0 0 4px var(--color-main-background);
}
.list-item--compact[data-v-56c9c89e] {
  --list-item-padding: calc(0.5 * var(--default-grid-baseline)) var(--default-grid-baseline);
}
.list-item--compact[data-v-56c9c89e]:not(:has(.list-item-content__subname)) {
  --list-item-height: var(--default-clickable-area);
}
.list-item--one-line[data-v-56c9c89e] {
  --list-item-height: var(--default-clickable-area);
  --list-item-border-radius: var(--border-radius-element, calc(var(--default-clickable-area) / 2));
  --list-item-padding: var(--default-grid-baseline);
}
.list-item--one-line .list-item-content__main[data-v-56c9c89e] {
  display: flex;
  justify-content: start;
  gap: 12px;
  min-width: 0;
}
.list-item--one-line .list-item-content__details[data-v-56c9c89e] {
  flex-direction: row;
  align-items: center;
  justify-content: end;
}
.list-item--one-line .list-item-content__name[data-v-56c9c89e] {
  align-self: center;
  max-width: 300px;
}
.list-item__anchor[data-v-56c9c89e] {
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  height: var(--list-item-height);
  min-width: 0;
}
.list-item__anchor[data-v-56c9c89e]:focus-visible {
  outline: none;
}
.list-item-content[data-v-56c9c89e] {
  display: flex;
  flex: 1 0;
  justify-content: space-between;
  padding-inline-start: calc(2 * var(--default-grid-baseline));
  min-width: 0;
}
.list-item-content__main[data-v-56c9c89e] {
  flex: 1 0;
  width: 0;
  margin: auto 0;
}
.list-item-content__main--oneline[data-v-56c9c89e] {
  display: flex;
}
.list-item-content__details[data-v-56c9c89e] {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
}
.list-item-content__actions[data-v-56c9c89e], .list-item-content__extra-actions[data-v-56c9c89e] {
  flex: 0 0 auto;
  align-self: center;
  justify-content: center;
  margin-inline-start: var(--default-grid-baseline);
}
.list-item-content__extra-actions[data-v-56c9c89e] {
  display: flex;
  align-items: center;
  gap: var(--default-grid-baseline);
}
.list-item-details__details[data-v-56c9c89e] {
  color: var(--color-text-maxcontrast);
  margin: 0 9px !important;
  font-weight: normal;
}
.list-item-details__extra[data-v-56c9c89e] {
  margin: 2px 4px 0 4px;
  display: flex;
  align-items: center;
}
.list-item-details__indicator[data-v-56c9c89e] {
  margin: 0 5px;
}
.list-item__extra[data-v-56c9c89e] {
  margin-top: var(--default-grid-baseline);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcListItem-BRTO5Id3.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8CAA8C;EAC9C,mDAAmD;AACrD;AACA;EACE,oDAAoD;AACtD;AACA;;;;;;;EAOE,mDAAmD;AACrD;AACA;;;;EAIE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,6DAA6D;EAC7D,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,iCAAiC;EACjC,WAAW;EACX,iDAAiD;EACjD,eAAe;EACf,+DAA+D;EAC/D,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;EACzC,kDAAkD;AACpD;AACA;EACE,0FAA0F;AAC5F;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;EACjD,gGAAgG;EAChG,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,4DAA4D;EAC5D,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;AAC1C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-56c9c89e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.list-item__wrapper[data-v-56c9c89e] {\n  display: flex;\n  position: relative;\n  width: 100%;\n  padding: 2px 4px;\n}\n.list-item__wrapper[data-v-56c9c89e]:first-of-type {\n  padding-block-start: 4px;\n}\n.list-item__wrapper[data-v-56c9c89e]:last-of-type {\n  padding-block-end: 4px;\n}\n.list-item__wrapper--active .list-item[data-v-56c9c89e], .list-item__wrapper.active .list-item[data-v-56c9c89e] {\n  background-color: var(--color-primary-element);\n  color: var(--color-primary-element-text) !important;\n}\n.list-item__wrapper--active .list-item[data-v-56c9c89e]:hover, .list-item__wrapper--active .list-item[data-v-56c9c89e]:focus-within, .list-item__wrapper--active .list-item[data-v-56c9c89e]:has(:focus-visible), .list-item__wrapper--active .list-item[data-v-56c9c89e]:has(:active), .list-item__wrapper.active .list-item[data-v-56c9c89e]:hover, .list-item__wrapper.active .list-item[data-v-56c9c89e]:focus-within, .list-item__wrapper.active .list-item[data-v-56c9c89e]:has(:focus-visible), .list-item__wrapper.active .list-item[data-v-56c9c89e]:has(:active) {\n  background-color: var(--color-primary-element-hover);\n}\n.list-item__wrapper--active .list-item-content__name[data-v-56c9c89e],\n.list-item__wrapper--active .list-item-content__subname[data-v-56c9c89e],\n.list-item__wrapper--active .list-item-content__details[data-v-56c9c89e],\n.list-item__wrapper--active .list-item-details__details[data-v-56c9c89e], .list-item__wrapper.active .list-item-content__name[data-v-56c9c89e],\n.list-item__wrapper.active .list-item-content__subname[data-v-56c9c89e],\n.list-item__wrapper.active .list-item-content__details[data-v-56c9c89e],\n.list-item__wrapper.active .list-item-details__details[data-v-56c9c89e] {\n  color: var(--color-primary-element-text) !important;\n}\n.list-item__wrapper .list-item-content__name[data-v-56c9c89e],\n.list-item__wrapper .list-item-content__subname[data-v-56c9c89e],\n.list-item__wrapper .list-item-content__details[data-v-56c9c89e],\n.list-item__wrapper .list-item-details__details[data-v-56c9c89e] {\n  white-space: nowrap;\n  margin-block: 0;\n  margin-inline: 0 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.list-item-content__name[data-v-56c9c89e] {\n  min-width: 100px;\n  flex: 1 1 10%;\n  font-weight: 500;\n}\n.list-item-content__subname[data-v-56c9c89e] {\n  flex: 1 0;\n  min-width: 0;\n  color: var(--color-text-maxcontrast);\n}\n.list-item-content__subname--bold[data-v-56c9c89e] {\n  font-weight: 500;\n}\n.list-item[data-v-56c9c89e] {\n  --list-item-padding: var(--default-grid-baseline);\n  --list-item-height: 2lh;\n  --list-item-border-radius: var(--border-radius-element, 32px);\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  justify-content: flex-start;\n  padding: var(--list-item-padding);\n  width: 100%;\n  border-radius: var(--border-radius-element, 32px);\n  cursor: pointer;\n  transition: background-color var(--animation-quick) ease-in-out;\n  list-style: none;\n}\n.list-item[data-v-56c9c89e]:hover, .list-item[data-v-56c9c89e]:focus-within, .list-item[data-v-56c9c89e]:has(:active), .list-item[data-v-56c9c89e]:has(:focus-visible) {\n  background-color: var(--color-background-hover);\n}\n.list-item[data-v-56c9c89e]:has(.list-item__anchor:focus-visible) {\n  outline: 2px solid var(--color-main-text);\n  box-shadow: 0 0 0 4px var(--color-main-background);\n}\n.list-item--compact[data-v-56c9c89e] {\n  --list-item-padding: calc(0.5 * var(--default-grid-baseline)) var(--default-grid-baseline);\n}\n.list-item--compact[data-v-56c9c89e]:not(:has(.list-item-content__subname)) {\n  --list-item-height: var(--default-clickable-area);\n}\n.list-item--one-line[data-v-56c9c89e] {\n  --list-item-height: var(--default-clickable-area);\n  --list-item-border-radius: var(--border-radius-element, calc(var(--default-clickable-area) / 2));\n  --list-item-padding: var(--default-grid-baseline);\n}\n.list-item--one-line .list-item-content__main[data-v-56c9c89e] {\n  display: flex;\n  justify-content: start;\n  gap: 12px;\n  min-width: 0;\n}\n.list-item--one-line .list-item-content__details[data-v-56c9c89e] {\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n}\n.list-item--one-line .list-item-content__name[data-v-56c9c89e] {\n  align-self: center;\n  max-width: 300px;\n}\n.list-item__anchor[data-v-56c9c89e] {\n  color: inherit;\n  display: flex;\n  flex: 1 0 auto;\n  align-items: center;\n  height: var(--list-item-height);\n  min-width: 0;\n}\n.list-item__anchor[data-v-56c9c89e]:focus-visible {\n  outline: none;\n}\n.list-item-content[data-v-56c9c89e] {\n  display: flex;\n  flex: 1 0;\n  justify-content: space-between;\n  padding-inline-start: calc(2 * var(--default-grid-baseline));\n  min-width: 0;\n}\n.list-item-content__main[data-v-56c9c89e] {\n  flex: 1 0;\n  width: 0;\n  margin: auto 0;\n}\n.list-item-content__main--oneline[data-v-56c9c89e] {\n  display: flex;\n}\n.list-item-content__details[data-v-56c9c89e] {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: end;\n}\n.list-item-content__actions[data-v-56c9c89e], .list-item-content__extra-actions[data-v-56c9c89e] {\n  flex: 0 0 auto;\n  align-self: center;\n  justify-content: center;\n  margin-inline-start: var(--default-grid-baseline);\n}\n.list-item-content__extra-actions[data-v-56c9c89e] {\n  display: flex;\n  align-items: center;\n  gap: var(--default-grid-baseline);\n}\n.list-item-details__details[data-v-56c9c89e] {\n  color: var(--color-text-maxcontrast);\n  margin: 0 9px !important;\n  font-weight: normal;\n}\n.list-item-details__extra[data-v-56c9c89e] {\n  margin: 2px 4px 0 4px;\n  display: flex;\n  align-items: center;\n}\n.list-item-details__indicator[data-v-56c9c89e] {\n  margin: 0 5px;\n}\n.list-item__extra[data-v-56c9c89e] {\n  margin-top: var(--default-grid-baseline);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
